// extracted by mini-css-extract-plugin
module.exports = {"MissingInformation":"MissingInformation_MissingInformation__3L_-M","Title":"MissingInformation_Title__3eB8U","SubTitle":"MissingInformation_SubTitle__3j_6o"};